import {FolderView} from "../files/files";
import {CompanyBase} from "@models/company";
import {BuilderVESummary, DeveloperVESummary} from "@/src/components/ve/ve_model";
import {BidConfigMetaData, DataSheetConfig} from "../project_conf/bidConfig_model";


/**
 * Can bidders see the amount of other bidders?
 * */
export enum AmountViewMode {
    // the amounts are visible
    Visible = 'visible',

    // They do not see an amount, but they see a ranking
    Ranked = 'ranked',

    // NO - they can't see the amounts
    Hidden = 'hidden',

    LowMediumHigh = 'lowmidhigh'
}

/**
 * Can bidders see the names of other bidders?
 * */
export enum NameViewMode {

    // they can see the names, and this corresponds to either a ranking or a list of amounts
    Visible = 'visible',

    // They can see the names, but as an independant list
    Detached = 'detached',

    // NO - they can't see the names
    Hidden = 'hidden'
}

export interface BidderViewMode {
    // Define the possible statuses here
    names: NameViewMode;
    amounts: AmountViewMode;
}

export interface BidConfig {
    bid_view_mode: BidderViewMode,
}


export interface BidViewItem {
    name: string;
    amount: number | string
    yours: boolean;
}


export interface LinkedBidViewItem extends BidViewItem {
    url: string;
}


export interface BidPartial {
    /**
     * user editable parts of the BID
     * */
    title: string;
    bid_amount: number;
    project_id: string;
    id: string;
}

/**
 * The data that bidders have access to for market feedback.
 * Since there are 9 modes of displaying this feedback, we get an object that supports all 9 modes.
 * */
export interface BiddingView {
    latest: BidBaseModel | BidPartial;
    names: string[] | null;
    items: BidViewItem[] | null;
    ranking: number | null;
    num_bidders: number;
    mode: BidderViewMode;
}


export interface DeveloperBiddingView {
    items: LinkedBidViewItem[];
}

export enum BidStatus {
    // Define the possible statuses here
    Draft = 'draft',
    Submitted = 'submitted',
    Accepted = 'accepted'
}

export enum BidResponseStatus {
    // Define the possible statuses here
    rejected = 'rejected',
    in_review = 'in_review',
    validate = 'validate'
}


export interface BidSummary {
    bid_amount: number;
    created_at: Date;
    status: BidStatus;
    submitted_at?: Date;
    _id: string;
}

export interface BidSummaryModel {
    /**
     * Used by developer for
     * */
    company: CompanyBase;
    latest_bid?: BidSummary;
    ve_summary: BuilderVESummary;
    num_bids?: number;
    project_id: string;

}

export interface BidEditableModel {
    /**
     * user editable parts of the BID
     * */
    title: string;
    bid_amount: number;
    description: string;
    inclusions: string;
    exclusions: string;
    status: BidStatus;
}


export function blank_bid(): BidEditableModel {
    return {
        title: "",
        bid_amount: 0,
        description: "",
        inclusions: "",
        exclusions: "",
        status: BidStatus.Draft,
    };
}


export interface BidSubmitModel{
    status: BidStatus;
}

export interface BidBaseModel extends BidEditableModel {

    // indexers
    id: string;
    project_id: string;
    company_id: string;
    company_name: string;
    created_by: string;
    number: number;

    // business data - Commented in for reference
    // title: string;
    // bid_amount: number;
    // description: string;
    // inclusions: string;
    // exclusions: string;
    // status: BidStatus;

    is_latest: boolean;
    created_at: Date;
    submitted_at?: Date;
    modified_at: Date;

    response_status: BidResponseStatus;

    // tool.period
    period: string;

    // tool.root
    root:FolderView;

    // todo - i shoud rename this...
    template_id: string |null;
    custom_data?: DataSheetConfig | null;

}

export interface ProjectCard {
    name: string;
    company_name: string;
}

export interface BidExtendedModel extends BidBaseModel {
    project: ProjectCard | null
}
